import React, { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import classNames from 'classnames';
//
import './collapsableBox.scss';

interface Props {
  headline: string;
  children?: JSX.Element;
}

const CollapsibleBox: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [innerHeight, setInnerHeight] = useState<number>(0);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(innerRef.current?.clientHeight || 0);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classNames('collapsable-box', { 'is-open': isOpen })}>
      <div className="collapsable-box__header" onClick={handleClick}>
        <h5 className="collapsable-box__headline">{!!props.headline && parse(props.headline)}</h5>
        <span className="collapsable-box__toggle"></span>
      </div>
      <div className="collapsable-box__content" style={{ height: isOpen ? innerHeight : 0 }}>
        <div className="collapsable-box-content__inner" ref={innerRef}>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleBox;
